import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_SUBMITTING_WORKWITHUS = 'SET_SUBMITTING_WORKWITHUS';
const setSubmitting = () => ({
    type: SET_SUBMITTING_WORKWITHUS,
});

export const UNSET_SUBMITTING_WORKWITHUS = 'UNSET_SUBMITTING_WORKWITHUS';
const unsetSubmitting = () => ({
    type: UNSET_SUBMITTING_WORKWITHUS,
});

export const SET_SUBMITTED_WORKWITHUS = 'SET_SUBMITTED_WORKWITHUS';
const setSubmitted = () => ({
    type: SET_SUBMITTED_WORKWITHUS,
});

export const sendCurriculum = (data) => (dispatch) => {
    dispatch(setSubmitting());

    const query = 'api/v1/workWithUs/sendCurriculum';

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            if (json.status === 'success') {
                dispatch(setSubmitted());

                showSuccess('Agradeçemos o contato. Sua mensagem foi enviada com sucesso e retornaremos o mais breve possível :)');
            } else {
                throw `error from server: ${json.message}`;
            }
        }).catch((error) => {
            dispatch(unsetSubmitting());

            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            // eslint-disable-next-line no-console
            console.log('sendCurriculum -> got error: ', error);
        });
};
